import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FPG_PLANS } from '../../constants';
import s from './index.module.scss';

export const FpgPlans = ({ plan, setPlan }) => {
  const { t } = useTranslation('fpg-v1');
  return (
    <div className={s.wrapper}>
      <div className={s.desc}>{t('fpg.plan_description')}</div>
      <div className={s.cards}>
        {Object.keys(FPG_PLANS).map(id => (
          <div
            key={id}
            className={classnames(s.link, plan === id && s.link_active)}
            onClick={() => setPlan(id)}
          >
            {id}
          </div>
        ))}
      </div>
    </div>
  );
};
